import React from 'react';
import { FormControlLabel, Switch, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import './StyledSwitch.scss';

const StyledSwitch = ({checked, onChange, label, tooltip, ...rest}) => (
    <div className="styled-switch-container">
        <FormControlLabel
            control={
                <Switch
                    checked={checked}
                    onChange={(event) => onChange(event.target.checked)}
                    color="primary"
                />
            }
            label={label}
            className="rse-form-control"
            {...rest}
        />
        {tooltip && (
            <Tooltip title={<div style={{ whiteSpace: 'pre-line' }}>{tooltip}</div>} arrow placement="right">
                <InfoIcon style={{ width: '15px', height: '15px', fontSize: '15px' }} className="styled-switch-info-icon" />
            </Tooltip>
        )}
    </div>
);

export default StyledSwitch;
